import { FC } from 'react';
import { Box } from '@mui/material';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { CoreTextField } from '../../../_core/components/_ui/core-textfield';
import { useTranslation } from 'react-i18next';

export type TranslateQuestionOptionsProps = {
	questionIndex: number;
};

export const TranslateQuestionOptions: FC<TranslateQuestionOptionsProps> = (props) => {
	const { questionIndex } = props;
	const [t] = useTranslation();
	const {
		watch,
		getValues,
		control,
		formState: { errors },
	} = useFormContext();
	const { fields } = useFieldArray({
		control,
		name: `questions.${questionIndex}.options`,
	});

	return (
		<Box sx={{ marginTop: '16px' }}>
			{fields.map((field, index) => (
				<Box key={field.id} sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
					<Controller
						name={`questions.${questionIndex}.options.${index}.translatedText`}
						control={control}
						render={({ field }) => (
							<CoreTextField
								{...field}
								fullWidth
								placeholder={getValues(`questions.${questionIndex}.options.${index}.text`)}
							/>
						)}
					/>
				</Box>
			))}
		</Box>
	);
};
